import { IconProps } from "../../types/genereal";
import { IconWrapper } from "../ui/IconWrapper";

export const InfuseDataIcon = ({
  width = "24",
  height = "24",
  style,
}: IconProps) => {
  return (
    <IconWrapper width={width} height={height} style={style}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.25648 9.22854L1.10648 15.4419C0.779811 15.9319 0.913145 16.3352 1.40648 16.3352H4.58315C5.07648 16.3352 5.74648 15.9319 6.07648 15.4419L10.2265 9.22854C10.5531 8.73854 10.4198 8.33521 9.92648 8.33521H6.74981C6.25648 8.33521 5.58314 8.73854 5.25648 9.22854Z"
          fill="#1C3D70"
        />
        <path
          d="M11.5866 9.22854L7.43656 15.4419C7.10989 15.9319 7.24322 16.3352 7.73656 16.3352H10.9132C11.4066 16.3352 12.0766 15.9319 12.4066 15.4419L16.5566 9.22854C16.8832 8.73854 16.7499 8.33521 16.2566 8.33521H13.0799C12.5866 8.33521 11.9132 8.73854 11.5866 9.22854Z"
          fill="#0861A8"
        />
        <path
          d="M17.9244 9.22854L13.7744 15.4419C13.4478 15.9319 13.5811 16.3352 14.0744 16.3352H17.2511C17.7444 16.3352 18.4144 15.9319 18.7444 15.4419L22.8944 9.22854C23.2211 8.73854 23.0878 8.33521 22.5944 8.33521H19.4178C18.9244 8.33521 18.2511 8.73854 17.9244 9.22854Z"
          fill="#2194D1"
        />
      </svg>
    </IconWrapper>
  );
};
